export class RequestEquipmentClass {
    ID?: number;
    RequestID?: number;
    EquipmentClassID: number;
}

export default RequestEquipmentClass;